import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/departments/profile/loading';

export const Route = createFileRoute('/_private/settings/departments/$id')({
  pendingComponent: Loading,
});
